/**
 * KKM — Ambalaj Fotoğraf Popup
 * kahve-wizard.js'ten sonra yükleyin
 */
(function() {
  /* ── Popup fonksiyonu ── */
  window.kwAmbPopup = function(imgs, isim) {
    let ov = document.getElementById('kw-amb-popup');
    if (ov) ov.remove();
    ov = document.createElement('div');
    ov.id = 'kw-amb-popup';
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(28,24,18,.75);z-index:99999;display:flex;align-items:center;justify-content:center;';
    ov.addEventListener('click', function(e) { if (e.target === ov) ov.remove(); });
    document.body.appendChild(ov);

    const imgList = Array.isArray(imgs) ? imgs.filter(Boolean) : [];
    let cur = 0;

    function render() {
      const thumbs = imgList.length > 1 ? imgList.map(function(src, i) {
        return '<img src="' + src + '" class="kw-amb-thumb" data-idx="' + i + '" onclick="window._kwAmbGo(' + i + ')" style="width:56px;height:56px;object-fit:cover;cursor:pointer;border:2px solid ' + (i === cur ? '#5C5040' : 'transparent') + ';flex-shrink:0;border-radius:2px;">';
      }).join('') : '';

      const arrows = imgList.length > 1 ? [
        '<button onclick="window._kwAmbGo((' + '(window._kwAmbCur||0)-1+' + imgList.length + ')%' + imgList.length + ')" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:1px solid #D4C4A8;background:#fff;font-size:20px;cursor:pointer;z-index:2;line-height:1;">‹</button>',
        '<button onclick="window._kwAmbGo(((window._kwAmbCur||0)+1)%' + imgList.length + ')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:1px solid #D4C4A8;background:#fff;font-size:20px;cursor:pointer;z-index:2;line-height:1;">›</button>',
      ].join('') : '';

      ov.innerHTML = '<div style="background:#fff;max-width:700px;width:94%;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;">' +
        '<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid #E8DDD0;">' +
          '<span style="font-size:13px;font-weight:700;color:#1C1812;">' + isim + '</span>' +
          '<button onclick="document.getElementById(\'kw-amb-popup\').remove()" style="border:none;background:none;font-size:24px;cursor:pointer;color:#5C5040;line-height:1;padding:0 4px;">×</button>' +
        '</div>' +
        '<div style="position:relative;flex:1;min-height:0;background:#F7F5F2;display:flex;align-items:center;justify-content:center;min-height:300px;">' +
          '<img id="kw-amb-popup-img" src="' + imgList[cur] + '" style="max-width:100%;max-height:60vh;object-fit:contain;display:block;">' +
          arrows +
        '</div>' +
        (imgList.length > 1 ? '<div style="display:flex;gap:6px;padding:10px 14px;overflow-x:auto;border-top:1px solid #E8DDD0;">' + thumbs + '</div>' : '') +
        '</div>';
    }

    window._kwAmbCur = 0;
    window._kwAmbGo = function(idx) {
      cur = idx;
      window._kwAmbCur = idx;
      const img = document.getElementById('kw-amb-popup-img');
      if (img) img.src = imgList[idx];
      // Thumbnail border güncelle
      document.querySelectorAll('#kw-amb-popup .kw-amb-thumb').forEach(function(el) {
        el.style.border = '2px solid ' + (parseInt(el.dataset.idx) === idx ? '#5C5040' : 'transparent');
      });
    };

    render();
  };

  /* ── Wizard'ın ambalaj render'ına popup butonu ekle ── */
  document.addEventListener('DOMContentLoaded', function() {
    // MutationObserver ile ambalaj grid'i izle
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (!node.querySelectorAll) return;
          node.querySelectorAll('.kw-amb-card').forEach(function(card) {
            if (card.dataset.popupBound) return;
            card.dataset.popupBound = '1';
            const imgDiv = card.querySelector('div:first-child');
            if (!imgDiv) return;

            // window.KW_AMBALAJ_DATA'dan tüm fotoğrafları al
            const ambId = card.dataset.type;
            let imgs = [];
            if (ambId && window.KW_AMBALAJ_DATA && window.KW_AMBALAJ_DATA[ambId]) {
              const amb = window.KW_AMBALAJ_DATA[ambId];
              imgs = (amb.imgs || [amb.img1, amb.img2, amb.img3]).filter(Boolean);
            }
            // Fallback: card'daki img src'lerinden topla
            if (!imgs.length) {
              card.querySelectorAll('img').forEach(function(img) {
                const src = img.getAttribute('src') || img.src;
                if (src && !imgs.includes(src)) imgs.push(src);
              });
            }
            if (!imgs.length) return;

            // Popup butonu ekle
            const btn = document.createElement('span');
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
            btn.title = 'Tüm fotoğrafları gör';
            btn.style.cssText = 'position:absolute;bottom:8px;right:8px;width:28px;height:28px;border-radius:50%;background:rgba(28,24,18,.55);backdrop-filter:blur(4px);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:3;border:1px solid rgba(255,255,255,.2);transition:background .15s;';
            btn.onmouseenter = function(){ btn.style.background='rgba(28,24,18,.85)'; };
            btn.onmouseleave = function(){ btn.style.background='rgba(28,24,18,.55)'; };
            btn.addEventListener('click', function(e) {
              e.stopPropagation();
              const isim = (ambId && window.KW_AMBALAJ_DATA && window.KW_AMBALAJ_DATA[ambId]) ? (window.KW_AMBALAJ_DATA[ambId].isim || '') : '';
              window.kwAmbPopup(imgs, isim);
            });
            imgDiv.style.position = 'relative';
            imgDiv.appendChild(btn);
          });
        });
      });
    });



  const target = document.getElementById('kw-ambalaj-step');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    } else {
      // Fallback: body izle
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();